import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import { provideClarity } from 'ngx-clarity';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor, provideAuth } from 'angular-auth-oidc-client';
import { GraphQLModule } from './core/modules/graphql.module';
import { GraphqlInterceptor } from './core/interceptors/rbs-api-interceptor';
import { configOidcProductSettings } from './core/consts/oidc.config';
import { CatchRefreshTokenErrorInterceptor } from './core/interceptors/refresh-token-idp-interceptor';
import { FortifyApiInterceptor } from './core/interceptors/fortify-api-interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SmartClientInterceptor } from '@core/interceptors/smart-client-interceptor';
import { RequestStatusInterceptor } from '@core/interceptors/request-status-interceptor';
import { roleAccessInterceptor } from '@core/interceptors/projects-departments-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
      withComponentInputBinding(),
    ),
    provideClarity({
      enabled: !isDevMode(),
      projectId: 'qjnqj0ux1u',
    }),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([
        authInterceptor(),
        GraphqlInterceptor,
        FortifyApiInterceptor,
        CatchRefreshTokenErrorInterceptor,
        SmartClientInterceptor,
        RequestStatusInterceptor,
        roleAccessInterceptor,
      ]),
    ),
    provideAuth({
      config: configOidcProductSettings,
    }),
    importProvidersFrom(GraphQLModule, BrowserAnimationsModule),
  ],
};
